import { render, staticRenderFns } from "./consumePanel.vue?vue&type=template&id=3bbefb3c&"
import script from "./consumePanel.vue?vue&type=script&lang=js&"
export * from "./consumePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports